import * as Sentry from '@sentry/browser';
import { prependMessageToError } from '@wix/cashier-common/dist/src/utils/errorHandling';

const sentryClient = new Sentry.Hub();

export const captureError = (
  error: Error | object | string,
  params?: {
    messagePrefix?: string;
    shouldRethrow?: boolean;
    fingerprint?: string[];
  },
) => {
  const { messagePrefix, shouldRethrow = false, fingerprint } = params || {};

  try {
    sentryClient.withScope((scope) => {
      if (fingerprint) {
        scope.setFingerprint(fingerprint);
      }

      if (error) {
        if (error instanceof Error) {
          let errorToReport: Error = error;

          if (messagePrefix) {
            errorToReport = prependMessageToError(error, messagePrefix);
          }

          sentryClient.captureException(errorToReport);
        } else if (typeof error === 'string') {
          sentryClient.captureMessage(error);
        } else {
          Object.keys(error).forEach((key) => {
            scope.setExtra(key, error[key]);
          });

          sentryClient.captureMessage(messagePrefix || 'Manually captured message');
        }
      }
    });
  } catch (e) {
    console.error(`Failed to exec captureError`, e);
  }

  console.error('Captured error:', error);

  if (shouldRethrow) {
    throw error;
  }
};
